export default __webpack_public_path__ + "static/media/Comments.6be3e6cf.svg";